var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.3115 20.9535C27.3484 20.9535 25.4256 20.647 23.6033 20.0457C22.7139 19.7392 21.7039 19.9754 21.1194 20.5717L17.5065 23.3001C13.361 21.0876 10.7079 18.4361 8.52549 14.3208L11.1803 10.7933C11.8486 10.125 12.0881 9.14684 11.8017 8.23067C11.1953 6.39661 10.8872 4.4721 10.8872 2.51242C10.8872 1.12721 9.75995 0 8.37475 0H2.51242C1.12721 0 0 1.12721 0 2.51242C0 18.6739 13.15 31.8239 29.3115 31.8239C30.6967 31.8239 31.8239 30.6967 31.8239 29.3115V23.466C31.8239 22.0808 30.6967 20.9535 29.3115 20.9535Z","fill":"#FF2017"}));
}

Phone.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
